/**
 * @generated SignedSource<<f5895ba259d5812c20535b4539baf2a5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CreateBulkProjectsForm_viewer$data = {
  readonly account: {
    readonly billing_method: string;
    readonly clients: ReadonlyArray<{
      readonly id: number;
      readonly image_key: string | null | undefined;
      readonly internal: boolean | null | undefined;
      readonly name: string;
      readonly real_client: boolean | null | undefined;
      readonly website: string | null | undefined;
    }>;
    readonly name: string;
  };
  readonly id: number;
  readonly permissions: any;
  readonly " $fragmentType": "CreateBulkProjectsForm_viewer";
};
export type CreateBulkProjectsForm_viewer$key = {
  readonly " $data"?: CreateBulkProjectsForm_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"CreateBulkProjectsForm_viewer">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CreateBulkProjectsForm_viewer",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "permissions",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "accounts",
      "kind": "LinkedField",
      "name": "account",
      "plural": false,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "billing_method",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "clients",
          "kind": "LinkedField",
          "name": "clients",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "image_key",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "website",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "internal",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "real_client",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "users",
  "abstractKey": null
};
})();

(node as any).hash = "2f70e10996d8fd9e4da486230035a6ac";

export default node;
